import { useCallback, useEffect, useState } from 'react';
function useSettingsModelState({
  flow,
  dataQuery,
  initialize,
  getDisabledTooltipMessage,
  useStaged = true
}) {
  const [hasChanged, setHasChanged] = useState(false);
  const [setting, setSetting] = useState(flow && !dataQuery ? initialize(flow) : null);

  /* initializer for staged mode */
  useEffect(() => {
    const hasDataQuery = dataQuery && !dataQuery.loading && dataQuery.data;
    const isUninitialized = setting === undefined || setting === null;
    if (flow && useStaged && isUninitialized && hasDataQuery) {
      setSetting(initialize(flow, dataQuery));
    }
    /* Omit initalize function from deps because its identity should not trigger reinitialize by design */
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [setting, flow, dataQuery, useStaged]);

  /* initializer for non-staged mode */
  useEffect(() => {
    if (flow && !useStaged) {
      setSetting(initialize(flow));
    }
    /* Omit initalize function from deps because its identity should not trigger reinitialize by design */
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [flow, useStaged]);
  const onChange = useCallback((newSetting, options) => {
    if (newSetting) {
      if (options && options.commitChange) {
        setHasChanged(false);
      } else {
        setHasChanged(true);
      }
      setSetting(newSetting);
    }
  }, []);
  const onClear = useCallback(() => {
    if (flow && setting) {
      onChange(initialize(flow, dataQuery), {
        commitChange: true
      });
    }

    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [flow, dataQuery, setting]);
  const onCommitChange = useCallback(() => {
    setHasChanged(false);
  }, []);
  return {
    setting,
    setSetting: onChange,
    onClear,
    hasChanged,
    onCommitChange,
    disabledTooltipMessage: getDisabledTooltipMessage && getDisabledTooltipMessage(setting)
  };
}
export default useSettingsModelState;